export const getIsAuth = () => JSON.parse(localStorage.getItem('authenticated')) ? JSON.parse(localStorage.getItem('authenticated')) : false
